import styled from '@emotion/styled/macro';

export const FiltersWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 1.5rem;
  flex-wrap: wrap;
`;
